<!--
 * @Author: ZWS
 * @Date: 2021-06-22 18:07:46
 * @LastEditTime: 2021-07-26 12:56:23
 * @Description: 查看图层组件
-->
<template class="templateBusines">
  <div class="djAnalysis">
    <div id="themeMap" class="basemap" ref="olmap"></div>
    <div class="tool_opt">
      <ul>
        <li
          v-for="item in toolsData"
          :key="item.id"
          :class="item.type"
          :style="changeStyle"
          @click="clickOptTool(item)"
        >
          <span class="li-span">{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <div
      id="bottom_property"
      v-show="resultShow"
      :style="{ height: hidebottom ? '33px' : '280px' }"
    >
      <div class="header">
        <div class="header-left">
          <div class="iconfont icon-chaxun"></div>
          <p>查询结果:{{ checkObj.serviceName }}</p>
        </div>
        <div class="iconfont icon-guanbi header-right" v-on:click.stop="bottomRemoveClick()"></div>
        <div
          class="arrow"
          :class="hidebottom ? 't2b' : 'b2t'"
          v-on:click.stop="bottomhideClick()"
        ></div>
      </div>
      <div class="content_table">
        <Table
          height="210"
          size="small"
          border
          :columns="columns1"
          :data="aData"
          @on-row-dblclick="ondbrowclick"
          @on-row-click="onrowclick"
          ref="table_property"
        ></Table>
        <Page
          :current.sync="pageinfo.current"
          :total="pageinfo.count"
          show-total
          class="pagecss"
          show-elevator
          @on-change="changepage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ViewLayer from './viewLayer';
export default ViewLayer;
</script>
<style lang="less" scoped>
.djAnalysis {
  position: absolute;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0px;
  .treeList {
    position: absolute;
    left: 0;
    top: 0;
    width: 20rem;
    height: 30rem;
    background: #ffffff;
    z-index: 3;
    border-bottom: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
    border-radius: 3px;
    .lefttitle {
      display: flex;
      height: 4rem;
      border-bottom: 1px solid #cccccc;
      line-height: 4rem;
      margin-right: 1rem;
      .bgnex {
        width: 0.5rem;
        background: #2d8cf0;
        height: 1.6rem;
        border-radius: 0.3rem;
        margin: 1.2rem 1rem 0 0rem;
      }
      .text {
        font-size: 1.4rem;
        font-weight: 600;
      }
    }
    .leftcenter {
      margin-left: 1rem;
    }
    .rightTree {
      height: 26rem;
      overflow-y: scroll;
    }
  }
  .basemap {
    position: absolute;
    top: 7rem;
    bottom: 0;
    left: 0;
    right: 0;
  }

  #Collapse {
    position: absolute;
    left: 10px;
    z-index: 52;
    width: 330px;
    margin-top: 10px;
    padding: 1px;
    background: #2d8cf0;
    .img {
      width: auto;
      height: 28px;
      margin-right: 0;
      background-repeat: no-repeat;
      border-bottom: 1px solid #c6e7fd;
    }
    .djAnalysis .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
      font-size: 14px;
    }
  }
  .tool_opt {
    position: absolute;
    top: 10px;
    right: 1%;
    height: 29px;
    z-index: 99;
    font-size: 12px;
    line-height: 22px;
    // width: 310px;
    text-align: center;
    background-color: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 2px;
    box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.15);
    ul {
      display: flex;
      flex-flow: row;
      margin-top: 0px;
      list-style: none;
      padding-inline-start: 0px;
      li {
        width: 60px;
        height: 29px;
        border-left: 1px #eee solid;
        background-color: rgb(255, 255, 255) !important;
        display: flex;
        .li-span {
          width: 100%;
          height: 29px;
          line-height: 29px;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          text-align: center;
          color: #333;
        }
      }

      li:hover {
        cursor: pointer;
      }

      li:first-child {
        border-left: 0px;
      }
    }
  }

  .tool_opt .fulls:hover .li-span,
  .tool_opt .zoomIn:hover .li-span,
  .tool_opt .zoomOut:hover .li-span,
  .tool_opt .print:hover .li-span,
  .tool_opt .distance:hover .li-span,
  .tool_opt .area:hover .li-span {
    color: #0099fa !important;
  }
  .ivu-collapse-content {
    height: 535px;
  }
  .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
    color: #f9f8f8;
  }
  #bottom_property {
    height: 280px;
    position: absolute;
    bottom: 0px;
    width: 100%;
    z-index: 1001;
    background: #ffffff;
  }
  #bottom_property .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 30px;
    line-height: 30px;
    background-color: #2d8cf0;
    border-bottom: 1px solid #dddddd;
    color: white;
  }
  #bottom_property {
    .header {
      display: flex;
      justify-content: space-between;
      .header-left {
        display: flex;
        padding-left: 1rem;
        font-size: 1.2rem;
        .icon-chaxun {
          font-size: 1.8rem;
          margin-right: 0.5rem;
          color: #ffffff;
        }
      }
      .icon-guanbi {
        position: absolute;
        right: 15px;
        top: 0px;
        font-size: 2rem;
        padding-right: 1rem;
        cursor: pointer;
        color: #ffffff;
      }
    }
  }
  #bottom_property .content_table {
    position: absolute;
    top: 30px;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
    // ::-webkit-scrollbar {
    // 	// color: #2d8cf0;
    // }
  }
  /deep/ .pagecss {
    float: left;
    margin-left: 10px;
  }
}
#bottom_property .header > .b2t {
  background-image: url(../../assets/l1.png);
  background-position: -155px -12px;
}
#bottom_property .header > .t2b {
  background-image: url(../../assets/l1.png);
  background-position: -112px -12px;
}
#bottom_property .header > .arrow {
  cursor: pointer;
  margin: 7px 5px 5px 0px;
  height: 16px;
  width: 16px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/viewLayer/viewLayer.vue